// @ts-check

/**
 * @file Defines an Expo route wrapper.
 */
import _ from "gettext-universal/build/src/translate.js"
import useLocale from "gettext-universal/build/src/use-locale-expo.js"
import {useLocalSearchParams} from "expo-router"
import {memo} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component.js"
import InvoiceEditScreen from "../../../src/screens/invoices/edit-screen"
import {optionalRouteParam} from "../../../src/shared/route-params"
import ScreenTitle from "../../../src/components/screen-title"

/** @import {NamedExoticComponent, ReactNode} from "react" */

/** @typedef {{[key: string]: unknown}} InvoiceEditRouteProps */

/** @typedef {Record<string, never>} InvoiceEditRouteState */

/**
 * Renders an Expo route screen.
 * @augments {ShapeComponent<InvoiceEditRouteProps, InvoiceEditRouteState>}
 */
class InvoiceEditRoute extends ShapeComponent {
  /** @type {ReturnType<typeof useLocalSearchParams>} */
  params

  /** Initializes route hooks. */
  setup() {
    useLocale()
    const params =
      /** @type {Record<string, string | string[]>} */ useLocalSearchParams()
    this.params = params
  }

  /**
   * Renders route content.
   * @returns {ReactNode} Rendered route content.
   */
  render() {
    const {params} = this.tt
    const invoiceID = optionalRouteParam(params, "id", "Invoice ID")
    const title =
      invoiceID
        ? _("Edit invoice %{id}", {
            id: invoiceID
          })
        : _("Edit invoice")
    return (
      <>
        <ScreenTitle>{title}</ScreenTitle>
        <InvoiceEditScreen />
      </>
    )
  }
}

/** @type {NamedExoticComponent<InvoiceEditRouteProps>} */
const InvoiceEditRouteComponent = memo(shapeComponent(InvoiceEditRoute))

export default InvoiceEditRouteComponent
